import { ErrorsContextProvider, ValidationErrors } from 'components';
import { ROUTING_PATHS } from 'const';
import { useIntParam } from 'hooks';
import { Modal } from 'semantic-ui-react';
import { Link, generatePath, useNavigate } from 'react-router';
import { Button, toast } from '@britishcouncil/react-admin';
import { useCallback, useEffect, useMemo } from 'react';
import { parseServerErrors } from 'utils';
import { lrwSessionStore } from 'store';

export const RemoveLrwSessionRoom = () => {
  const sessionId = useIntParam('sessionId');
  const sessionRoomId = useIntParam('sessionRoomId');
  const { lrwSessionDetails } = ROUTING_PATHS;
  const [removeRoom, { isSuccess, error: removeError, isLoading: isConfirming, reset }] =
    lrwSessionStore.service.useRemoveLrwSessionRoomMutation();
  const navigate = useNavigate();
  const errors = useMemo(() => parseServerErrors(removeError), [removeError]);

  const goToLrwSessionDetails = useCallback(() => {
    navigate(generatePath(lrwSessionDetails.absolutePath, { sessionId }));
  }, [navigate, lrwSessionDetails.absolutePath, sessionId]);

  useEffect(() => {
    if (isSuccess) {
      toast({
        type: 'success',
        message: 'Room removed successfully',
      });
      goToLrwSessionDetails();
      reset();
    }
  }, [goToLrwSessionDetails, isSuccess, sessionId, reset]);

  return (
    <ErrorsContextProvider generalErrors={errors}>
      <Modal open size="tiny">
        <Modal.Header>Remove room</Modal.Header>
        <Modal.Content>
          <ValidationErrors />
          <p>Are you sure you want to remove this room from the session?</p>
        </Modal.Content>

        <Modal.Actions>
          <Link to={generatePath(lrwSessionDetails.absolutePath, { sessionId })}>
            <Button compact type="reset" secondary>
              Cancel
            </Button>
          </Link>

          <Button
            compact
            color="red"
            onClick={() => {
              removeRoom({ lrwSessionId: sessionId, lrwSessionRoomId: sessionRoomId });
            }}
            loading={isConfirming}
            disabled={isConfirming}
          >
            Remove
          </Button>
        </Modal.Actions>
      </Modal>
    </ErrorsContextProvider>
  );
};
